<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>统计</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <div>
            <div class="filter">
              <el-form
                :inline="true"
                :model="filter"
                ref="filterForm"
                label-position="right"
                label-width="80px"
                class="search-form"
                size="small"
              >
                <el-form-item label="关键字" prop="query">
                  <el-input
                    v-model="filter.query"
                    clearable
                    placeholder="序列号，型号，零件号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="产品状态" prop="drill_status">
                  <el-select v-model="filter.drill_status">
                    <el-option :key="1" label="成品" :value="1"></el-option>
                    <el-option :key="2" label="半成品" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="结算状态" prop="status">
                  <el-select v-model="filter.status">
                    <el-option :key="1" label="待结算" :value="1"></el-option>
                    <el-option :key="10" label="已结算" :value="10"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="数据周期" prop="month" label-width="120px">
                  <el-date-picker
                    clearable
                    v-model="filter.month"
                    type="month"
                    size="small"
                    value-format="yyyy-MM"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
              <div style="margin-left: 80px">
                <el-button
                  type="primary"
                  size="small"
                  @click="
                    page = 1
                    getData()
                  "
                  >筛选</el-button
                >
                <el-button size="small" @click="getData(true)">重置</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="panel">
          <file-button
            obj="drill_cost"
            :importButton="false"
            :filter="filter"
            style="float: right"
          ></file-button>
          <div>
            <!-- <div class="pad-btm form-inline">
              <div class="row">
                <div class="col-md-12 text-right">
                  上次结算日期：{{ last_settle_date || '无' }}
                  <el-popconfirm
                    v-code="71102"
                    title="确认结算当前月份的材料出入库数据吗？"
                    @confirm="handleSettleStockData"
                  >
                    <el-button
                      slot="reference"
                      class="mr-10 ml-10"
                      type="primary"
                      >结算</el-button
                    >
                  </el-popconfirm>

                  <file-button
                    obj="drill_cost"
                    :importButton="false"
                    :filter="filter"
                    style="float: right"
                  ></file-button>
                </div>
              </div>
            </div> -->
            <div>
              <el-button
                @click="handleBatchAddDrillCost(6)"
                class="mr-10"
                type="primary"
                >添加人工成本</el-button
              >
              <el-button
                @click="handleBatchAddDrillCost(7)"
                class="mr-10 ml-10"
                type="primary"
                >添加制造成本</el-button
              >
              <el-table
                v-loading="loading"
                border
                size="small"
                :data="drills"
                style="width: 100%; margin-top: 15px"
              >
                <el-table-column
                  prop="serial_number"
                  label="序列号/型号/零件号"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div v-if="!scope.row.produce_end_date">
                      <el-tag type="danger" size="mini" effect="plain"
                        >半成品</el-tag
                      >
                    </div>
                    <DrillLink :no="scope.row.serial_number"></DrillLink>
                    <div>{{ scope.row.model_number || '-' }}</div>
                    <div>{{ scope.row.component_number || '-' }}</div>
                    <div></div>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                label="型号"
                prop="model_number"
              ></el-table-column>
              <el-table-column
                label="零件号"
                prop="component_number"
              ></el-table-column> -->
                <el-table-column
                  label="生产周期"
                  align="center"
                  min-width="120"
                >
                  <template slot-scope="scope">
                    {{ scope.row.produce_start_date || '-' }} 至
                    {{ scope.row.produce_end_date || '-' }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="材料明细"
                  min-width="300"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-tag
                      v-for="(item, index) in scope.row.costs"
                      class="mg5"
                      :key="item.id + index.toString()"
                      size="small"
                      effect="plain"
                      :closable="item.category == 5 && scope.row.status != 10"
                      @close="handleClose(scope.row.serial_number, item.id)"
                    >
                      {{ item.name }}
                      <i class="ml-10 text-danger"
                        >{{ item.number }}
                        <span
                          style="
                            display: inline-block;
                            width: 20px;
                            text-align: right;
                          "
                          >x</span
                        >
                        <span
                          style="
                            display: inline-block;
                            width: 40px;
                            text-align: right;
                          "
                          >{{ item.price.toFixed(2) }}</span
                        ></i
                      >
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="历史成本" align="center">
                  <template slot-scope="scope">
                    {{
                      (
                        scope.row.total_cost - scope.row.pre_month_amount
                      ).toFixed(2)
                    }}
                  </template>
                </el-table-column>
                <el-table-column label="上月成本" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.pre_month_amount.toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column label="总成本" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.total_cost.toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column label="状态" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.status == 10 ? '已结算' : '待结算' }}
                    <div v-if="scope.row.settle_time">
                      {{ $time(scope.row.settle_time).format('YYYY-MM-DD') }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120">
                  <template slot-scope="scope">
                    <template v-if="scope.row.status != 10">
                      <el-popconfirm
                        v-code="71102"
                        v-if="scope.row.produce_end_date"
                        title="确认结算该钻头成本吗？"
                        @confirm="
                          handleConfirmCost(
                            scope.row.serial_number,
                            scope.$index
                          )
                        "
                      >
                        <el-link
                          :underline="false"
                          slot="reference"
                          type="danger"
                          >结算成本</el-link
                        >
                      </el-popconfirm>
                      <el-link
                        v-code="71102"
                        :underline="false"
                        type="primary"
                        @click="handleAddDrillCost(scope.row, scope.$index)"
                        >添加成本</el-link
                      >
                      <!-- <el-link
                      v-code="71102"
                      :underline="false"
                      type="primary"
                      @click="handleEditDrillCost(scope.row, scope.$index)"
                      v-if="scope.row.is_new == 2"
                      >编辑基础成本</el-link
                    > -->
                    </template>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination
              background
              class="m-t-20 text-right"
              :page-size="filter.size"
              :current-page.sync="filter.page"
              @current-change="getData(false)"
              layout="total, prev, pager, next"
              :total="count"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <DrillCostFomer
      :model="model"
      :show.sync="formerVisible"
      @callback="callback"
    ></DrillCostFomer>
  </div>
</template>

<script>
import Vue from 'vue'

import {
  drillCostStatistic,
  drillUpdate,
  drillConfirmCost,
  drillCostDelete,
  itemSettleStock,
} from '@/service/getData'

import DrillCostFomer from './drill_cost_fomer.vue'
export default {
  components: {
    DrillCostFomer,
  },
  data() {
    return {
      model: {
        serial_number: '',
        name: '',
        price: 0,
        number: 1,
      },
      formerVisible: false,
      filter: {
        month: Vue.time(
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
        ).format('YYYY-MM'),
        query: '',
        status: '',
        drill_status: '',
        page: 1,
        size: 10,
        sum_cost: true,
      },
      count: 0,
      drills: [],
      exportLoading: false,
      loading: false,
      last_settle_date: '',
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.month = Vue.time(
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
        ).format('YYYY-MM')
        this.filter.query = ''
        this.filter.page = 1
        this.filter.status = ''
        this.filter.drill_status = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1

      this.loading = true
      let res = await drillCostStatistic(params)
      if (res.status == 0) {
        this.loading = false
        this.drills = res.data.list
        this.count = res.data.count
        this.last_settle_date = res.data.last_settle_date
      }
    },
    handleAddDrillCost(row, index) {
      this.model.category = 5
      this.model.name = ''
      this.model.serial_number = row.serial_number
      this.formerVisible = true
    },

    handleBatchAddDrillCost(category) {
      this.model.category = category
      this.model.serial_number = '000000'
      this.model.name = category == 6 ? '人工成本' : '制造成本'
      this.formerVisible = true
    },

    async handleClose(serial_number, costid) {
      let res = await drillCostDelete({
        serial_number: serial_number,
        id: costid,
      })
      if (res.code == 0) {
        this.getData()
      }
    },
    callback() {
      this.getData()
    },
    handleEditDrillCost(row, index) {
      this.$prompt('请输入本体成本', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]+(.[0-9]{2})?$/,
        inputValue: row.price.toFixed(2),
        inputErrorMessage: '格式不正确',
      }).then(({ value }) => {
        let drill = this.clone(row)
        drill.price = parseFloat(value)
        drillUpdate(drill).then((res) => {
          if (res.code == 0) {
            this.getData()
          }
        })
      })
    },
    async handleSettleStockData() {
      const loading = this.$loading({
        lock: true,
        text: '库存结算中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      let res = await itemSettleStock()
      if (res.code == 0) {
        this.getData()
        loading.close()
      } else {
        loading.close()
      }
    },
    async handleConfirmCost(number, index) {
      let res = await drillConfirmCost(number)
      if (res.code == 0) {
        this.getData()
      }
    },
  },
}
</script>

<style scoped>
.mg5 {
  margin-top: 3px;
  margin-bottom: 3px;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
  position: relative;
}

/deep/.mg5 .el-icon-close {
  position: absolute;
  right: -20px;
  top: 2px;
}
.ml5 {
  margin-left: 5px;
}
.ml-10 {
  margin-left: 10px;
}
</style>